import { useEffect, useState, useCallback } from 'react';
import { useMapsApiKey } from '../features/mapsApiKey/mapsApiKeySlice';

const getGoogleMapsSrc = (apiKey) => {
	const baseUrl =
		'https://maps.googleapis.com/maps/api/js?jsapiRedirect=true&language=en&channel=ddc-web-platform&libraries=places';
	if (apiKey) {
		return `${baseUrl}&key=${apiKey}`;
	}
	return baseUrl;
};

const CUSTOM_PIN_MARKER_SVG =
	'data:image/svg+xml;charset=UTF-8,%3Csvg width="28" height="45" viewBox="0 0 28 45" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cg filter="url(%23filter0_f_4188_9024)"%3E%3Cellipse cx="13.7773" cy="40.4707" rx="4.5" ry="2.5" fill="black" fill-opacity="0.1"/%3E%3C/g%3E%3Cmask id="path-2-outside-1_4188_9024" maskUnits="userSpaceOnUse" x="0.277344" y="0.970703" width="27" height="40" fill="black"%3E%3Crect fill="white" x="0.277344" y="0.970703" width="27" height="40"/%3E%3Cpath d="M13.7773 1.9707C20.6809 1.9707 26.2773 7.56714 26.2773 14.4707C26.2773 17.2849 25.3468 19.8815 23.7773 21.9707C21.2773 25.4707 14.7773 29.9707 14.7773 38.9707C14.7773 39.523 14.3296 39.9707 13.7773 39.9707C13.2251 39.9707 12.7773 39.523 12.7773 38.9707C12.7773 29.9707 6.27734 25.4707 3.77734 21.9707C2.20792 19.8815 1.27734 17.2849 1.27734 14.4707C1.27734 7.56714 6.87378 1.9707 13.7773 1.9707Z"/%3E%3C/mask%3E%3Cpath d="M13.7773 1.9707C20.6809 1.9707 26.2773 7.56714 26.2773 14.4707C26.2773 17.2849 25.3468 19.8815 23.7773 21.9707C21.2773 25.4707 14.7773 29.9707 14.7773 38.9707C14.7773 39.523 14.3296 39.9707 13.7773 39.9707C13.2251 39.9707 12.7773 39.523 12.7773 38.9707C12.7773 29.9707 6.27734 25.4707 3.77734 21.9707C2.20792 19.8815 1.27734 17.2849 1.27734 14.4707C1.27734 7.56714 6.87378 1.9707 13.7773 1.9707Z" fill="%236393F2"/%3E%3Cpath d="M23.7773 21.9707L22.9778 21.3701L22.9706 21.3797L22.9636 21.3895L23.7773 21.9707ZM3.77734 21.9707L4.59108 21.3895L4.5841 21.3797L4.57688 21.3701L3.77734 21.9707ZM13.7773 1.9707V2.9707C20.1286 2.9707 25.2773 8.11943 25.2773 14.4707H26.2773H27.2773C27.2773 7.01486 21.2332 0.970703 13.7773 0.970703V1.9707ZM26.2773 14.4707H25.2773C25.2773 17.0607 24.4217 19.4479 22.9778 21.3701L23.7773 21.9707L24.5769 22.5713C26.2718 20.315 27.2773 17.5091 27.2773 14.4707H26.2773ZM23.7773 21.9707L22.9636 21.3895C22.3823 22.2033 21.56 23.0858 20.5772 24.1644C19.614 25.2216 18.5335 26.4296 17.5287 27.8234C15.5069 30.6278 13.7773 34.2034 13.7773 38.9707H14.7773H15.7773C15.7773 34.738 17.2978 31.5636 19.151 28.993C20.0837 27.6993 21.097 26.5635 22.0556 25.5114C22.9947 24.4807 23.9224 23.4881 24.5911 22.5519L23.7773 21.9707ZM14.7773 38.9707H13.7773V39.9707V40.9707C14.8819 40.9707 15.7773 40.0753 15.7773 38.9707H14.7773ZM13.7773 39.9707V38.9707H12.7773H11.7773C11.7773 40.0753 12.6728 40.9707 13.7773 40.9707V39.9707ZM12.7773 38.9707H13.7773C13.7773 34.2034 12.0478 30.6278 10.026 27.8234C9.0212 26.4296 7.94073 25.2216 6.97748 24.1644C5.99471 23.0858 5.17242 22.2033 4.59108 21.3895L3.77734 21.9707L2.96361 22.5519C3.63227 23.4881 4.55998 24.4807 5.49908 25.5114C6.45771 26.5635 7.47099 27.6993 8.40367 28.993C10.2569 31.5636 11.7773 34.738 11.7773 38.9707H12.7773ZM3.77734 21.9707L4.57688 21.3701C3.13297 19.4479 2.27734 17.0607 2.27734 14.4707H1.27734H0.277344C0.277344 17.5091 1.28287 20.315 2.9778 22.5713L3.77734 21.9707ZM1.27734 14.4707H2.27734C2.27734 8.11943 7.42607 2.9707 13.7773 2.9707V1.9707V0.970703C6.3215 0.970703 0.277344 7.01486 0.277344 14.4707H1.27734Z" fill="url(%23paint0_linear_4188_9024)" mask="url(path-2-outside-1_4188_9024)"/%3E%3Ccircle cx="13.7773" cy="14.4707" r="4.5" fill="black" fill-opacity="0.4"/%3E%3Cdefs%3E%3Cfilter id="filter0_f_4188_9024" x="7.27734" y="35.9707" width="13" height="9" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_4188_9024"/%3E%3C/filter%3E%3ClinearGradient id="paint0_linear_4188_9024" x1="13.7773" y1="1.9707" x2="13.7773" y2="39.9707" gradientUnits="userSpaceOnUse"%3E%3Cstop stop-color="white"/%3E%3Cstop offset="1" stop-color="white" stop-opacity="0.5"/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E';

export const useGoogleMaps = ({
	address,
	city,
	state,
	postalCode,
	fullAddress,
	mapRef
}) => {
	// Get API key from Redux state as fallback
	const mapsApiKey = useMapsApiKey();
	const GOOGLE_MAPS_SRC = getGoogleMapsSrc(mapsApiKey);

	// Validate required props
	const [mapLoaded, setMapLoaded] = useState(false);
	const [mapError, setMapError] = useState(false);
	const hasValidProps = address && city && state && postalCode;

	const initializeMap = useCallback(() => {
		if (!mapRef.current || !window.google?.maps) {
			setMapError(true);
			return;
		}

		try {
			if (mapLoaded) {
				return;
			}
			const geocoder = new window.google.maps.Geocoder();

			geocoder.geocode(
				{ address: fullAddress },
				async (results, status) => {
					if (status === 'OK' && results[0]) {
						const { location } = results[0].geometry;

						const map = new window.google.maps.Map(mapRef.current, {
							zoom: 15,
							center: location,
							disableDefaultUI: true,
							zoomControl: false,
							mapTypeControl: false,
							scaleControl: false,
							streetViewControl: false,
							rotateControl: false,
							fullscreenControl: false,
							gestureHandling: 'none',
							draggable: false,
							scrollwheel: false,
							disableDoubleClickZoom: true,
							keyboardShortcuts: false,
							styles: [
								{
									featureType: 'poi',
									elementType: 'labels',
									stylers: [{ visibility: 'off' }]
								}
							]
						});

						const marker = new window.google.maps.Marker({
							position: location,
							map,
							title: fullAddress,
							icon: {
								url: CUSTOM_PIN_MARKER_SVG,
								scaledSize: new window.google.maps.Size(32, 48),
								anchor: new window.google.maps.Point(14, 45)
							}
						});

						// Ensure marker is used to avoid linting warnings
						if (marker) {
							setMapLoaded(true);
						}
					} else {
						setMapError(true);
					}
				}
			);
		} catch (error) {
			setMapError(true);
		}
	}, [fullAddress, mapRef, mapLoaded]);

	useEffect(() => {
		if (mapLoaded) {
			return;
		}

		if (!hasValidProps) {
			setMapError(true);
			return;
		}

		// Check if Google Maps is already loaded
		if (window.google?.maps) {
			initializeMap();
			return;
		}

		// Check if script is already in the header
		let script = document.querySelector(
			'script[src*="maps.googleapis.com/maps/api/js"]'
		);
		let scriptAdded = false;

		if (!script) {
			script = document.createElement('script');
			script.src = GOOGLE_MAPS_SRC;
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);
			scriptAdded = true;
		}

		// Wait for Google Maps to load (from preload script)
		let attempts = 0;
		const maxAttempts = 10; // 1 second max

		const checkGoogleMaps = setInterval(() => {
			attempts += 1;
			if (window.google?.maps) {
				clearInterval(checkGoogleMaps);
				initializeMap();
			} else if (attempts >= maxAttempts) {
				clearInterval(checkGoogleMaps);
				setMapError(true);
			}
		}, 100);

		// Cleanup interval on unmount
		// eslint-disable-next-line consistent-return
		return () => {
			clearInterval(checkGoogleMaps);
			if (scriptAdded && script && script.parentNode) {
				script.parentNode.removeChild(script);
			}
		};
	}, [GOOGLE_MAPS_SRC, hasValidProps, initializeMap, mapLoaded]);

	return [mapLoaded, mapError];
};
